import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-produtos-edit',
  templateUrl: './produtos-edit.component.html',
  styleUrls: ['./produtos-edit.component.css'],
  standalone: false
})
export class ProdutosEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/produtos`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Produtos', link: '/produtos' }, { label: 'Edição Produtos' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'produtos',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('produtos').subscribe((data) => {
        this.fields = data;
    });
  }
}
